import { render, staticRenderFns } from "./_outrightDoubleMatch.vue?vue&type=template&id=d400a3a8&scoped=true&lang=pug&"
import script from "./_outrightDoubleMatch.vue?vue&type=script&lang=js&"
export * from "./_outrightDoubleMatch.vue?vue&type=script&lang=js&"
import style0 from "./_outrightDoubleMatch.vue?vue&type=style&index=0&id=d400a3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d400a3a8",
  null
  
)

export default component.exports